module.exports = __webpack_public_path__ + "static/media/setting-noti.4b682e3d.jpg";